<template>
  <div>
    <div class="modal fade" data-backdrop="static" id="modal-invoice-general-invoice-detail-pb">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title">{{ getTitle() }}</h1>
          </div>
          <div class="modal-body">
            <b-form>
              <div class="row">
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <!-- date ~ record_date -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('invoice_general_invoice.date')"
                  >
                    <div class="form-group">
                      <date-picker :config="options" :value="record_date" v-model="record_date"></date-picker>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <!-- user_created_full_name -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('invoice_general_invoice.user_created_full_name')"
                  >
                    <div class="form-group">
                      <div>
                        <input
                          :placeholder="
                            $t('invoice_general_invoice.user_created_full_name')
                          "
                          v-model="user_created_full_name"
                          class="form-control"
                          :disabled="true"
                        />
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <!-- customer -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('invoice_general_invoice.customer')"
                  >
                    <div class="form-group required">
                      <div>
                        <input
                          required
                          :placeholder="
                            $t('invoice_general_invoice.customer')
                          "
                          v-model="customer"
                          class="form-control"
                          :disabled="false"
                        />
                        <span v-if='error_msg.customer_name != ""' class="help is-danger">
                          <font color="red">{{ $t(error_msg.customer_name) }}</font>
                        </span>
                      </div>
                    </div>
                  </b-form-group>
                </div>

                <div class="col-sm-6 col-md-6 col-lg-6">
                  <!-- invoice_general_status -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('invoice_general_invoice.status_name')"
                  >
                    <div class="form-group">
                      <select
                        v-model="invoice_general_status"
                        class="form-control"
                        id="invoice_general_status"
                      >
                        <option
                          v-for="option in invoiceGeneralStatusText"
                          v-bind:value="option.id"
                          :key="option.id"
                        >{{ option.text }}</option>
                      </select>
                      <!-- <div>
                        <input :placeholder="$t('invoice_general_invoice.purpose_name')" v-model="purpose_name" class="form-control" />
                      </div>-->
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <!-- apartment_code -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('invoice_general_invoice.apartment_code')"
                  >
                    <div class="form-group">
                      <div>
                        <input
                          :disabled="true"
                          :placeholder="$t('invoice_general_invoice.apartment_code')"
                          v-model="apartment_code"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </b-form-group>
                </div>

                <div class="col-sm-6 col-md-6 col-lg-6">
                  <!-- type_name -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('invoice_general_invoice.type_name')"
                  >
                    <div class="form-group">
                      <div>
                        <select v-model="type" class="form-control">
                          <option
                            v-for="payment in payments_list"
                            v-bind:value="payment.id"
                            :key="payment.id"
                          >{{ $t(payment.text) }}</option>
                        </select>
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <!-- description -->
              <b-form-group
                label-size="sm"
                label-for="input-sm"
                :label="$t('invoice_general_invoice.note_retail_service')"
              >
                <div class="form-group">
                  <div>
                    <textarea
                      v-model="description"
                      :placeholder="$t('invoice_general_invoice.note_retail_service')"
                      class="md-textarea form-control"
                      rows="3"
                    ></textarea>

                    <span v-if='error_msg.description != ""' class="help is-danger">
                      <font color="red">{{ $t(error_msg.description) }}</font>
                    </span>
                  </div>
                </div>
              </b-form-group>
            </b-form>

            <div v-if="purpose == 4">
              <div class="col-xs-6"></div>
              <div class="col-xs-6"></div>
              <div class="col-xs-12">
                <div class="col-xs-12">
                  <div class="table-responsive customer-info">
                    <table class="table">
                      <tbody>
                        <tr>
                          <th style="width:16%">{{$t('apartmentbookings.services')}}:</th>
                          <td style="width:35%">
                            <select
                              class="form-control"
                              style="width:100%"
                              v-model="service_selected"
                            >
                              <option
                                v-for="option in services"
                                v-bind:value="option.id"
                                :key="option.id"
                              >{{option.name}}</option>
                            </select>
                          </td>
                          <td style="width:25%">
                            <input
                              type="checkbox"
                              @change="onChangeSelectService()"
                              v-model="checkbox_select_service"
                            />
                            <button class="btn btn-info" @click="onAddInvoiceGeneralService()">
                              <i class="glyphicon glyphicon-plus"></i>
                              {{ $t(`common.add`) }}
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-xs-12">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th style="width: 5%;">{{$t('common.nonumber')}}</th>
                      <th style="width: 25%;">{{$t('apartmentbookings.basicService.service')}}</th>
                      <th style="width: 15%;">Số Lượng</th>
                      <th style="width: 15%;">Đơn Giá</th>
                      <th style="width: 25%;" class="text-center">T.Tiền</th>
                      <th style="width: 5%;" class="text-center">Thao Tác</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for=" (item, index) in invoice_general_service" :key="index">
                      <td>{{index + 1}}</td>
                      <td>{{$t(`${item.service.name}`)}}</td>
                      <td>
                        <input
                          class="form-control basic-input"
                          v-model="item.quantity"
                          @change="onChangeUnitPrice(item)"
                          v-on:keyup="onChangeUnitPrice(item)"
                        />
                      </td>
                      <td>
                        <input
                          class="form-control basic-input"
                          v-model="item.unit_price"
                          @change="onChangeUnitPrice(item)"
                          v-on:keyup="onChangeUnitPrice(item)"
                        />
                      </td>
                      <td class="text-center">{{formatNumber(item.price)}}</td>
                      <td class="text-center">
                        <button
                          type="button"
                          class="btn btn-sm btn-warning"
                          @click="onRemoveGeneralService(item, index)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>

                    <br />
                    <br />

                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>Phụ Thu</td>
                      <td class="text-center">
                        <!-- // Phụ Thu -->
                        <b-form-input
                          @input="onFormatAmount()"
                          v-model="extra_fee"
                          :value="extra_fee"
                          class="form-control"
                          type="number"
                        />
                      </td>
                      <td class="text-center"></td>
                    </tr>

                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>Giảm Trừ</td>
                      <td class="text-center">
                        <!-- // Giảm Trừ -->
                        <b-form-input
                          @input="onFormatAmount()"
                          v-model="discount"
                          :value="discount"
                          class="form-control"
                          type="number"
                        />
                      </td>
                      <td class="text-center"></td>
                    </tr>

                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>Trả Trước</td>
                      <td class="text-center">
                        <!-- // Trả Trước -->
                        <b-form-input
                          @input="onFormatAmount()"
                          v-model="pay_in_advance"
                          :value="pay_in_advance"
                          class="form-control"
                          type="number"
                        />
                      </td>
                      <td class="text-center"></td>
                    </tr>

                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>Tiền Phải Trả</td>
                      <td class="text-center">
                        <span>{{payables}}</span>
                      </td>
                      <td class="text-center"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-xs-12">
              <hr />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="editOrAddInvoiceGeneralInvoiceDetail(null)"
              :class="'btn btn-primary btn-sm pull-right'"
            >{{ $t("common.save") }}</button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="closeModal"
            >{{ $t("common.back") }}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <div class="modal fade" id="modal-confirm">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title">
              {{
              typeUpdate == null
              ? $t("invoice_general_invoice.confirm_checkin")
              : typeUpdate == "check_out"
              ? $t("invoice_general_invoice.checkout")
              : $t("invoice_general_invoice.cancelled_room")
              }}
            </h1>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              @click="editOrAddInvoiceGeneralInvoiceDetail(typeUpdate)"
              class="btn btn-primary btn-sm pull-right"
            >Xác Nhận</button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="closeConfirmModal"
            >{{ $t("common.back") }}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import utils from '@/lib/utils';
import i18n from "../lang";
import constantsData from "../lib/constantsData";

const InvoiceGeneralStatusEnum = {
  PAID: 1,
  UNPAID: 2,
  PICKUP: 3
}

export default {
  name: "lte-modal",
  props: {
    type_booking: {
      type: String,
      default: () => {
        return "normal";
      }
    }
  },
  data() {
    return {
      id: "",
      code: "",
      customer: "",
      address: "",
      description: "",
      amount: 0,
      type_name: "",
      purpose: "4",
      purpose_name: "",
      correlation_key: "",
      correlation_key_enable: true,
      user_created_full_name: "",
      type: 1,
      record_date: new Date(), //moment(new Date()).format("DD-MM-YYYY"), //utils.addTimeZoneForTimestamp(new Date(), "DD/MM/YYYY"),
      deposit_deadline: utils.addTimeZoneForTimestamp(new Date(), "DD/MM/YYYY"),
      booking_code: 0,
      checkin_datetime_feture: utils.addTimeZoneForTimestamp(new Date(), "DD/MM/YYYY"),
      apartment_code: "",
      apartment:"",

      options: {
        format: "DD/MM/YYYY",
        useCurrent: true
      },

      invoiceGeneralStatusText: [
        { id: InvoiceGeneralStatusEnum.PAID, text: 'invoice_general_status.paid' },
        { id: InvoiceGeneralStatusEnum.UNPAID, text: 'invoice_general_status.unpaid' },
        { id: InvoiceGeneralStatusEnum.PICKUP, text: 'invoice_general_status.pickup' }
      ],

      payments_list: constantsData.paymentsType,
      invoice_general_status: InvoiceGeneralStatusEnum.UNPAID,

      invoice_general_invoice_id: null,
      typeUpdate: null,

      callBackFrom: "",
      checkbox_select_service: false,

      // Phụ Thu
      extra_fee: 0,
      // Giảm Trừ
      discount: 0,
      // Trả Trước
      pay_in_advance: 0,
      // Tiền Phải Trả
      payables: 0,

      error_msg: {
        customer_name: "",
        description: ""
      },

      services: {},
      service_selected: 0,

      invoice_general_service: [],
      feeGroup: 2
    };
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    onChangeSelectService() {
    },
    onFormatAmount() {
      // Tiền trả = T.Tiền + Phụ Thu - Giảm Trừ - Trả Trước
      this.payables =
        parseFloat(this.amount) +
        parseFloat(this.extra_fee) -
        parseFloat(this.discount) -
        parseFloat(this.pay_in_advance);
      this.payables = utils.formatNumber(
        utils.formatInteger(this.payables.toString())
      );
    },
    onChangeUnitPrice: function(item) {
      item["price"] = Math.round(item["quantity"] * item["unit_price"]);
      this.setTotalAmountForPurpose4();
    },
    onRemoveGeneralService: function(item, index) {
      this.invoice_general_service.splice(index, 1);
      this.setTotalAmountForPurpose4();
    },
    formatNumber: function(n) {
      if (n !== null || n !== 0) {
        return utils.formatNumber(n);
      }
      return 0;
    },

    onAddInvoiceGeneralService: function() {
      let service_selected = this.services.filter(
        x => x.id == this.service_selected
      );
      let service = {
        id: service_selected[0].id,
        name: service_selected[0].name
      };
      let item = {
        general_invoice: this.invoice_general_invoice_id,
        service: service,
        quantity: 0,
        unit_price: 0,
        price: 0
      };
      this.invoice_general_service.push(item);
      this.setTotalAmountForPurpose4();
    },

    setTotalAmountForPurpose4: function() {
      let amount = 0;
      this.invoice_general_service.forEach(v => {
        amount += v.price;
      });
      this.amount = amount;
      this.onFormatAmount();
    },

    getTextPurpose(name) {
      let purpose_name = this.$t("invoice_general_status." + name);
      return purpose_name;
    },

    getTitle() {
      return this.invoice_general_invoice_id == 0
        ? this.$t("invoice_general_invoice.add_retail_service")
        : this.$t("invoice_general_invoice.update");
    },
    // with from
    //INVOICE_GENERAL_INVOICE
    // BOOKING
    setCallBackFrom(from) {
      this.callBackFrom = from;
    },
    setValueDefault(object_data_default) {
      this.purpose = object_data_default.purpose;
      this.apartment_code = object_data_default.apartment_code;
      this.apartment = object_data_default.apartment;
      this.invoice_general_status = InvoiceGeneralStatusEnum.UNPAID
      this.setEditCorrelationKey(true);
    },

    setEditCorrelationKey(val) {
      this.correlation_key_enable = val;
    },

    getCheckinDatetime(booking_code) {
      if (booking_code != 0) {
        this.GET_BOOKING_DETAIL_BY_BOOKING_CODE({
          booking_code: booking_code
        }).then(
          function(res) {
            let booking_data = res.data;
            this.checkin_datetime_feture = utils.addTimeZoneForTimestamp(booking_data.checkin_datetime, "DD/MM/YYYY");
            this.apartment_code =
              booking_data.apartment_mapping_with_booking_ids[0].apartment_details.apartment_code;
          }.bind(this)
        );
      }
    },

    async submit(invoice_general_invoice_id) {
      this.invoice_general_invoice_id = invoice_general_invoice_id;

      // set empty when change invoice_general_invoice_id

      if (
        invoice_general_invoice_id != null &&
        invoice_general_invoice_id != 0
      ) {
        this.GET_INVOICE_GENERAL_INVOICE_DETAIL({
          id: invoice_general_invoice_id
        })
          .then(
            function(res) {
              let data = res.data;

              this.id = data.id;
              this.type = data.type;
              this.purpose = data.purpose;
              this.code = data.code;
              this.customer = data.customer;
              this.address = data.address;
              this.description = data.description;
              this.amount = data.amount;
              this.type_name = data.type_name;
              this.purpose_name = data.purpose_name;
              this.correlation_key = data.correlation_key;
              this.user_created_full_name = utils.getFullName(
                data.user_created_first_name,
                data.user_created_last_name,
                i18n.locale
              );

              this.extra_fee = data.extra_fee;
              this.discount = data.discount;
              this.pay_in_advance = data.pay_in_advance;
              this.apartment_code = data.apartment_code;
              this.apartment = data.apartment;
              this.status = data.status;
              this.apartment = data.apartment;

              if (data.record_date != null) {
                this.record_date = utils.addTimeZoneForTimestamp(data.record_date, "DD/MM/YYYY");
              }

              this.getCheckinDatetime(this.correlation_key);

              this.invoice_general_service = data.invoice_general_service;

              this.onFormatAmount();

              $("#modal-invoice-general-invoice-detail-pb").modal("show");
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ERROR_TOAST();
            }.bind(this)
          );
      } else {
        this.getCheckinDatetime(this.booking_code);
        $("#modal-invoice-general-invoice-detail-pb").modal("show");
      }
    },

    validateCustomerName: function() {
      this.error_msg.customer_name = "";
      let result = true;
      if (this.customer == null || this.customer == "") {
        this.error_msg.customer_name = "common.error_msg[0].required";
        result = false;
      }
      return result;
    },
    validateDescription: function() {
      this.error_msg.description = "";
      let result = true;
      if (this.customer == null || this.customer == "") {
        this.error_msg.description = "common.error_msg[0].required";
        result = false;
      }
      return result;
    },

    checkForm: function() {
      let customer = this.validateCustomerName();
      let description = this.validateDescription();
      if (customer && description) {
        return true;
      } else {
        return false;
      }
    },
    editOrAddInvoiceGeneralInvoiceDetail: function(status_booking) {
      if (this.checkForm() == false) {
        return;
      }

      let data = {
        id: this.invoice_general_invoice_id,
        amount: utils.formatInteger(this.amount.toString()),
        customer: this.customer,
        address: this.address,
        description: this.description,
        correlation_key: this.correlation_key,
        purpose: this.purpose,
        type: this.type,

        extra_fee: this.extra_fee,
        discount: this.discount,
        pay_in_advance: this.pay_in_advance,
        apartment:this.apartment,
        status: this.invoice_general_status,

        user_created: this.GET_ACCOUNT_DATA.id,
        record_date: utils.formatSqlDate(this.record_date, "DD-MM-YYYY", "YYYY-MM-DDThh:mm"),
        invoice_general_service: this.invoice_general_service,
        type_booking: this.type_booking
      };

      if (this.invoice_general_invoice_id == 0) {
        this.ADD_INVOICE_GENERAL_INVOICE({
          id: this.invoice_general_invoice_id,
          ...data
        })
          .then(
            function(res) {
              // Update success
              $("#modal-invoice-general-invoice-detail-pb").modal("hide");
              this.SUCCESS_TOAST();
              // this.$emit("callbackGetLeaseBackAvailableApartment");
              this.$emit("callbackInvoiceGeneralInvoiceSuccess");
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error,
                styleType: "danger"
              });
            }.bind(this)
          );
      } else {
        this.UPDATE_INVOICE_GENERAL_INVOICE({
          id: this.invoice_general_invoice_id,
          ...data
        })
          .then(
            function(res) {
              // Update success
              $("#modal-invoice-general-invoice-detail-pb").modal("hide");
              this.SUCCESS_TOAST();
              // this.$emit("callbackGetLeaseBackAvailableApartment");
              this.$emit("callbackInvoiceGeneralInvoiceSuccess");
            }.bind(this)
          )
          .catch(
            function(error) {
              $("#modal-invoice-general-invoice-detail-pb").modal("hide");
              $("#modal-confirm").modal("hide");
              this.disabledCheckin = true;
              let error_data = error.response.data;
              if (
                !utils.isNull(error_data.error_code) &&
                error_data.error_code == "checkout_late"
              ) {
                this.ON_SHOW_TOAST({
                  message: this.$t(
                    "invoice_general_invoice.invalid_checkout_time"
                  ),
                  styleType: "danger"
                });
              } else if (
                !utils.isNull(error_data.error_code) &&
                error_data.error_code == "invalid_checkin_time"
              ) {
                this.ON_SHOW_TOAST({
                  message: this.$t(
                    "invoice_general_invoice.invalid_checkin_time"
                  ),
                  styleType: "danger"
                });
              } else if (
                !utils.isNull(error_data.error_code) &&
                error_data.error_code == "checked_out"
              ) {
                this.ON_SHOW_TOAST({
                  message: this.$t(
                    "invoice_general_invoice.invalid_checked_out"
                  ),
                  styleType: "danger"
                });
              } else if (
                !utils.isNull(error_data.error_code) &&
                error_data.error_code == "cancelled_room"
              ) {
                this.ON_SHOW_TOAST({
                  message: this.$t(
                    "invoice_general_invoice.invalid_cancelled_room"
                  ),
                  styleType: "danger"
                });
              } else if (
                !utils.isNull(error_data.error_code) &&
                error_data.error_code == "cannot_checkout"
              ) {
                this.ON_SHOW_TOAST({
                  message: this.$t("invoice_general_invoice.cannot_check_out"),
                  styleType: "danger"
                });
              } else {
                // Show error toast
                this.ERROR_TOAST();
              }
            }.bind(this)
          );
      }
    },
    onShowModalConfirm: function(type) {
      this.typeUpdate = type;
      $("#modal-confirm").modal("show");
    },
    updateDateCheckinCheckout: function() {
      this.disabledCheckin = false;
    },
    closeModal: function() {
      $("#modal-invoice-general-invoice-detail-pb").modal("hide");
      this.disabledCheckin = true;
    },
    closeConfirmModal: function() {
      $("#modal-confirm").modal("hide");
    },
    getServicesByGroup: function(feegroup) {
      const data = {
        params: {
          feegroup: feegroup
        }
      };
      this.GET_SERVICES_BY_GROUP(data).then(
        function(res) {
          let data = res.data;
          let services = [];
          data.forEach(v => {
            let item = {
              id: v.id,
              name: v.name,
              price: v.service_fee[0].fee_value
                ? v.service_fee[0].fee_value
                : 0,
              vat: v.vat ? v.vat : 0,
              feegroup: v.feegroup,
              service_type: v.service_type,
              isChecked: false
            };
            services.push(item);
          });

          this.service_selected = services[0].id;
          this.services = services;
        }.bind(this)
      );
    },
    getFullName(firstname, lastname) {
      return utils.getFullName(firstname, lastname, i18n.locale);
    },
    ...mapActions([
      "GET_INVOICE_GENERAL_INVOICE_DETAIL",
      "ADD_INVOICE_GENERAL_INVOICE",
      "UPDATE_INVOICE_GENERAL_INVOICE",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "GET_BOOKING_DETAIL_BY_BOOKING_CODE",
      "GET_SERVICES_BY_GROUP",
      "SET_USER_DATA"
    ])
  },
  async mounted() {
    await this.SET_USER_DATA()
    this.user_created_full_name = this.getFullName(
      this.GET_ACCOUNT_DATA.firstname,
      this.GET_ACCOUNT_DATA.lastname
    );

    this.getServicesByGroup(this.feeGroup);
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker
  }
};
</script>
<style lang="scss" scoped>
.mg-left {
  margin-left: 5px;
}
.hide-scroll-bar::-webkit-scrollbar {
  display: none;
}

#modal-invoice-general-invoice-detail-pb .modal-dialog {
  width: 1024px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/LTEModalInvoiceGeneralInvoiceDetailPB.vue